"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var product_1 = require("../../ducks/product");
var GenericButton_1 = __importDefault(require("../../../common/GenericButton"));
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var tags_module_scss_1 = __importDefault(require("./tags.module.scss"));
var onPlatform_1 = require("../../ducks/onPlatform");
var track_event_1 = __importDefault(require("../../../../utils/track-event"));
var styled_components_1 = __importDefault(require("styled-components"));
var Tags = function () {
    var tags = (0, react_redux_1.useSelector)(product_1.tagsSelector);
    var onPlatform = (0, react_redux_1.useSelector)(onPlatform_1.onPlatformSelector);
    return tags ? (react_1.default.createElement("div", { className: tags_module_scss_1.default.root }, tags.map(function (tag) {
        return (react_1.default.createElement("div", { key: tag.name, className: tags_module_scss_1.default.tag },
            react_1.default.createElement("a", { href: onPlatform !== 'vtb' ? tag.path : '' },
                react_1.default.createElement(TagButton, { onClick: track_event_1.default.bind(null, {
                        category: 'closeup',
                        action: 'click',
                        label: 'tag',
                    }) }, tag.name))));
    }))) : null;
};
var TagButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  color: #949899;\n  border: 1px solid #ebecec;\n  padding: 2px 8px;\n  font-size: 13px;\n\n  &:hover {\n    color: #2a3133;\n  }\n"], ["\n  background-color: white;\n  color: #949899;\n  border: 1px solid #ebecec;\n  padding: 2px 8px;\n  font-size: 13px;\n\n  &:hover {\n    color: #2a3133;\n  }\n"])));
exports.default = (0, withErrorBoundary_1.default)(Tags);
var templateObject_1;
